module.exports = __webpack_public_path__ + "img/ActivationCodeField.aa8081f1.jpg";